import React from "react";
import { MessengerService, PluginWrapper } from "@vlogr/plugin-sdk";
//import { Main } from "@vlogrinc/vlogr.dropbox-components-react-lib";
import { Main } from './dropbox-components-react-lib';

interface IItem {
  type: string;
  file: string;
  size: string;
}

const getDataType = (extension: string): string => {
  if (extension) {
    extension = extension.toLowerCase();
    switch (extension) {
      case "mp3":
      case "aac":
      case "aif":
      case "aiff":
      case "flac":
      case "m4a":
      case "wav":
        return "audio";
      case "mp4":
      case "3gp":
      case "3gpp":
      case "3gpp2":
      case "asf":
      case "avi":
      case "dv":
      case "m2t":
      case "m4v":
      case "mkv":
      case "mov":
      case "mpeg":
      case "mpg":
      case "mts":
      case "oggtheora":
      case "ogv":
      case "rm":
      case "ts":
      case "vob":
      case "webm":
      case "wmv":
      case "flv":
      case "gif":
        return "video";
      case "png":
      case "jpg":
      case "tiff":
      case "svg":
      case "svgz":
      case "bmp":
      case "tif":
        return "image";
      default:
        return "";
    }
  }
  return "";
};

function App() {
  const messengerService = new MessengerService(window as unknown as Window);

  const create = (data: IItem[]) => {
    messengerService.create(data, (data: any): void => {
      // do nothing
    });
  };

  const componentCallback = (data: any): void => {
    const elements = [];
    const fileUrl = data.file || data.mp4;
    elements.push({
      type: getDataType(fileUrl.split(".").pop()),
      file: fileUrl,
      size: data.fileSize,
      thumbnail: data.thumbnail
    });
    
    create(elements);
  };

  return (
    <PluginWrapper messenger={messengerService}>
      <Main getDropboxFileData={componentCallback} />
    </PluginWrapper>
  );
}

export default App;
